export default "__VITE_ASSET__BtM_DzW2__"